/* Buy a Brick — donation wall. Rotation ported from examples/buy-a-brick.html; search + scroll are new. */
(function exposeBrickDonationWall(root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.WYWBrickDonationWall = api;
    if (!root.document || root.WYWBrickDonationWallInitialized) return;
    root.WYWBrickDonationWallInitialized = true;
    var initialize = function () { api.initializeDonationWalls(root.document); };
    if (root.document.readyState !== 'loading') initialize();
    else root.document.addEventListener('DOMContentLoaded', initialize, { once: true });
    root.document.addEventListener('shopify:section:load', function (event) {
      api.initializeDonationWalls(event.target);
    });
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function buildBrickDonationWall(browserRoot) {
  function normalizeEntry(entry) {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return null;
    var key = typeof entry.key === 'string' ? entry.key.trim() : '';
    var name = typeof entry.name === 'string' ? entry.name.trim() : '';
    var tier = typeof entry.tier === 'string' ? entry.tier.trim() : 'brick';
    var date = typeof entry.date === 'string' ? entry.date.trim() : '';
    return key ? { key: key, name: name, tier: tier || 'brick', date: date } : null;
  }

  function parseDataPage(html, parseDocument) {
    var parser = parseDocument || function (markup) {
      if (!browserRoot || !browserRoot.DOMParser) throw new Error('DOMParser is unavailable');
      return new browserRoot.DOMParser().parseFromString(markup, 'text/html');
    };
    var documentObject = parser(String(html));
    var root = documentObject && documentObject.querySelector
      ? documentObject.querySelector('[data-donor-wall-page]')
      : null;
    if (!root) throw new Error('Donor wall refresh returned no page data');
    var page = Number(root.dataset && root.dataset.currentPage);
    var pages = Number(root.dataset && root.dataset.totalPages);
    var entryCount = Number(root.dataset && root.dataset.entryCount);
    var pageParam = root.dataset && typeof root.dataset.pageParam === 'string'
      ? root.dataset.pageParam.trim()
      : '';
    if (![page, pages, entryCount].every(Number.isInteger)
      || page < 1
      || pages < 1
      || page > pages
      || entryCount < 0
      || (pages > 1 && !pageParam)) {
      throw new Error('Invalid donor wall page metadata');
    }
    var elements = root.querySelectorAll ? root.querySelectorAll('[data-donor-wall-entry]') : [];
    var entries = Array.prototype.map.call(elements, function (element) {
      return normalizeEntry({
        key: element.dataset && element.dataset.entryKey,
        name: element.dataset && element.dataset.name,
        tier: element.dataset && element.dataset.tier,
        date: element.dataset && element.dataset.date,
      });
    });
    if (entries.some(function (entry) { return entry === null; })) {
      throw new Error('Invalid donor wall entry');
    }
    return { page: page, pages: pages, entryCount: entryCount, pageParam: pageParam, entries: entries };
  }

  async function fetchAllEntryPages(fetchPage, maxPages) {
    if (typeof fetchPage !== 'function') throw new Error('Donor wall page fetcher is unavailable');
    var pageLimit = Number.isInteger(maxPages) ? maxPages : Infinity;
    var firstPage = await fetchPage(1, null);
    if (!firstPage || firstPage.page !== 1 || !Number.isInteger(firstPage.pages) || firstPage.pages < 1) {
      throw new Error('Incomplete donor wall refresh');
    }
    if (firstPage.pages > pageLimit) throw new Error('Donor wall refresh exceeds ' + pageLimit + ' pages');
    var entries = firstPage.entries.slice();
    for (var page = 2; page <= firstPage.pages; page += 1) {
      var responsePage = await fetchPage(page, firstPage.pageParam);
      if (!responsePage
        || responsePage.page !== page
        || responsePage.pages !== firstPage.pages
        || responsePage.entryCount !== firstPage.entryCount
        || responsePage.pageParam !== firstPage.pageParam) {
        throw new Error('Incomplete donor wall refresh');
      }
      entries.push.apply(entries, responsePage.entries);
    }
    if (entries.length !== firstPage.entryCount) throw new Error('Donor wall entry count mismatch');
    return entries;
  }

  function createEntryFetcher(options) {
    var settings = options || {};
    var fetchImpl = settings.fetchImpl || (browserRoot && browserRoot.fetch && browserRoot.fetch.bind(browserRoot));
    var routesRoot = settings.routesRoot || (browserRoot && browserRoot.Shopify && browserRoot.Shopify.routes.root) || '/';
    var now = settings.now || Date.now;
    var parsePage = settings.parsePage || function (html) { return parseDataPage(html); };
    return async function fetchEntries() {
      if (typeof fetchImpl !== 'function') throw new Error('Donor wall fetch is unavailable');
      return fetchAllEntryPages(async function (page, pageParam) {
        var parameters = new URLSearchParams({
          section_id: 'brick-donation-wall-data',
          _donor_wall: String(now()),
        });
        if (pageParam) parameters.set(pageParam, String(page));
        var separator = routesRoot.indexOf('?') === -1 ? '?' : '&';
        var response = await fetchImpl(routesRoot + separator + parameters, {
          headers: { Accept: 'text/html' },
          cache: 'no-store',
        });
        if (!response || !response.ok) {
          throw new Error('Donor wall refresh failed: ' + ((response && response.status) || 'network'));
        }
        return parsePage(await response.text(), page);
      });
    };
  }

  function getHorizontalWheelDelta(strip, event) {
    if (!strip || !event) return 0;
    var deltaX = Number(event.deltaX) || 0;
    var deltaY = Number(event.deltaY) || 0;
    if (!deltaY || Math.abs(deltaX) >= Math.abs(deltaY)) return 0;

    var multiplier = event.deltaMode === 1
      ? 16
      : event.deltaMode === 2
        ? Number(strip.clientWidth) || 1
        : 1;
    var requestedDelta = deltaY * multiplier;
    var currentPosition = Math.max(0, Number(strip.scrollLeft) || 0);
    var maximumPosition = Math.max(0, (Number(strip.scrollWidth) || 0) - (Number(strip.clientWidth) || 0));
    if (maximumPosition <= 0
      || (requestedDelta < 0 && currentPosition <= 0)
      || (requestedDelta > 0 && currentPosition >= maximumPosition)) {
      return 0;
    }
    return Math.max(-currentPosition, Math.min(requestedDelta, maximumPosition - currentPosition));
  }

  function rnd(seed) { var x = Math.sin(seed) * 10000; return x - Math.floor(x); }

  function sortAndDedupeEntries(entries) {
    var seen = new Set();
    return (Array.isArray(entries) ? entries : []).map(function (entry, sourceIndex) {
      var normalized = normalizeEntry(entry);
      return normalized ? Object.assign({ sourceIndex: sourceIndex }, normalized) : null;
    }).filter(function (entry) {
      if (!entry || !entry.name || seen.has(entry.key)) return false;
      seen.add(entry.key);
      return true;
    }).sort(function (left, right) {
      var byDate = right.date.localeCompare(left.date);
      if (byDate) return byDate;
      var byName = right.name.localeCompare(left.name);
      if (byName) return byName;
      var byTier = right.tier.localeCompare(left.tier);
      return byTier || left.sourceIndex - right.sourceIndex;
    }).map(function (entry) {
      return { key: entry.key, name: entry.name, tier: entry.tier, date: entry.date };
    });
  }

  function createBrick(entry, documentObject) {
    var labels = { brick: 'Brick', row: 'Row', wall: 'Wall', cornerstone: 'Cornerstone' };
    var tier = Object.prototype.hasOwnProperty.call(labels, entry.tier) ? entry.tier : 'brick';
    var brick = documentObject.createElement('div');
    brick.classList.add('fbrick', 'tier-' + tier);
    brick.dataset.entryKey = entry.key;
    brick.dataset.name = entry.name;
    brick.dataset.date = entry.date;
    var name = documentObject.createElement('span');
    name.classList.add('nm');
    name.textContent = entry.name;
    var tag = documentObject.createElement('span');
    tag.classList.add('tag');
    tag.textContent = labels[tier];
    brick.appendChild(name);
    brick.appendChild(tag);
    return brick;
  }

  function decorateBricks(bricks) {
    bricks.forEach(function (element, index) {
      var rotation = (rnd(index + 1) * 1.2 - 0.6).toFixed(2);
      element.dataset.rot = rotation;
      element.style.transform = 'rotate(' + rotation + 'deg)';
      element.addEventListener('mouseenter', function () {
        element.style.transform = 'translateY(-4px) rotate(0deg)';
      });
      element.addEventListener('mouseleave', function () {
        element.style.transform = 'rotate(' + element.dataset.rot + 'deg)';
      });
    });
  }

  function initializeDonationWall(root, options) {
    var settings = options || {};
    if (root.dataset.init) return root.donationWallReady || Promise.resolve(false);
    root.dataset.init = '1';
    var allBricks = Array.prototype.slice.call(root.querySelectorAll('.fbrick'));
    decorateBricks(allBricks);
    var moreBrick = root.querySelector('.fbrick.tier-more');
    // nameBricks stays in original DOM order — we only reorder the live DOM, never this array,
    // so clearing the search restores the original order by re-appending in array order.
    var nameBricks = allBricks.filter(function (el) { return el !== moreBrick; });
    var input = root.querySelector('.wall-search');
    var strip = root.querySelector('.founders');
    var scrollFrame = root.querySelector('.wall-scroll');
    var empty = root.querySelector('.wall-empty');

    function updateScrollCues() {
      if (!strip || !scrollFrame) return;
      var maximumPosition = Math.max(0, (Number(strip.scrollWidth) || 0) - (Number(strip.clientWidth) || 0));
      var currentPosition = Math.max(0, Number(strip.scrollLeft) || 0);
      scrollFrame.classList.toggle('has-scroll-left', currentPosition > 1);
      scrollFrame.classList.toggle('has-scroll-right', currentPosition < maximumPosition - 1);
    }

    function applySearch() {
      var q = input ? input.value.trim().toLowerCase() : '';
      if (!q) {
        nameBricks.forEach(function (el) { el.classList.remove('is-dim'); strip.appendChild(el); });
        if (moreBrick) { moreBrick.classList.remove('is-dim'); strip.appendChild(moreBrick); }
        if (empty) empty.style.display = 'none';
        strip.scrollLeft = 0;
        updateScrollCues();
        return;
      }
      // Matches rise to the top; non-matches stay below but recede (.is-dim).
      var matched = [], rest = [];
      nameBricks.forEach(function (el) {
        var isMatch = (el.dataset.name || '').toLowerCase().indexOf(q) !== -1;
        el.classList.toggle('is-dim', !isMatch);
        (isMatch ? matched : rest).push(el);
      });
      matched.concat(rest).forEach(function (el) { strip.appendChild(el); });
      if (moreBrick) { moreBrick.classList.add('is-dim'); strip.appendChild(moreBrick); }
      if (empty) empty.style.display = matched.length === 0 ? 'block' : 'none';
      strip.scrollLeft = 0;
      updateScrollCues();
    }

    if (input && strip) {
      input.addEventListener('input', applySearch);
    }
    if (strip) {
      strip.setAttribute('tabindex', '0');
      strip.setAttribute('role', 'region');
      strip.setAttribute('aria-label', 'Founders wall, scroll horizontally');
      strip.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { strip.scrollLeft += 120; e.preventDefault(); updateScrollCues(); }
        if (e.key === 'ArrowLeft') { strip.scrollLeft -= 120; e.preventDefault(); updateScrollCues(); }
      });
      strip.addEventListener('wheel', function (e) {
        var horizontalDelta = getHorizontalWheelDelta(strip, e);
        if (!horizontalDelta) return;
        strip.scrollLeft += horizontalDelta;
        e.preventDefault();
        updateScrollCues();
      }, { passive: false });
      strip.addEventListener('scroll', updateScrollCues, { passive: true });
    }

    if (!strip) return Promise.resolve(false);
    var documentObject = settings.document || root.ownerDocument || (browserRoot && browserRoot.document);
    var fetchEntries = settings.fetchEntries || createEntryFetcher();
    var reportError = settings.reportError || function (error) {
      if (browserRoot && browserRoot.console && browserRoot.console.warn) {
        browserRoot.console.warn('[Brick donation wall]', error);
      }
    };
    root.dataset.loadState = 'loading';
    root.donationWallReady = Promise.resolve().then(fetchEntries).then(function (entries) {
      var completeEntries = sortAndDedupeEntries(entries);
      var completeBricks = completeEntries.map(function (entry) {
        return createBrick(entry, documentObject);
      });
      nameBricks.forEach(function (brick) { brick.remove(); });
      completeBricks.forEach(function (brick) {
        if (moreBrick) strip.insertBefore(brick, moreBrick);
        else strip.appendChild(brick);
      });
      nameBricks = completeBricks;
      decorateBricks(nameBricks);
      root.dataset.entryCount = String(nameBricks.length);
      root.dataset.loadState = 'complete';
      applySearch();
      updateScrollCues();
      return true;
    }).catch(function (error) {
      root.dataset.loadState = 'error';
      reportError(error);
      return false;
    });
    return root.donationWallReady;
  }

  function initializeDonationWalls(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('.brick-donation-wall')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('.brick-donation-wall')));
    }
    roots.forEach(function (root) { initializeDonationWall(root); });
    return roots.length;
  }

  return {
    createEntryFetcher: createEntryFetcher,
    fetchAllEntryPages: fetchAllEntryPages,
    getHorizontalWheelDelta: getHorizontalWheelDelta,
    initializeDonationWall: initializeDonationWall,
    initializeDonationWalls: initializeDonationWalls,
    normalizeEntry: normalizeEntry,
    parseDataPage: parseDataPage,
    sortAndDedupeEntries: sortAndDedupeEntries,
  };
});
